// extracted by mini-css-extract-plugin
export default {"timer":"Discount_timer__ScIy2"};